export const environment = {
  production: false,

  clientName: 'demo',
  apiGatewayFront: 'https://ecommerceagp.plexa.co/',
  apiGatewayBackOffice: 'https://ecommerceagp.plexa.co/',
  apiUrl: 'https://ecommerceagp.plexa.co/',
  urlPath: 'https://ecommerceagp.plexa.co/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  enableDebug: false,
  // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
  // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX

  siteKeyCaptcha: '6LdfIXkqAAAAAHWieN60TrVsCoIOv49juGEUEV3_',

  googleAnalyticsCode: 'UA-140785247-1',
};